// @generated by TypeGen from LogbookModel/Log.swift - DO NOT EDIT

import type { IAuditLogEdit } from "./AuditLogEdit"
import type { ILogMetadata } from "./Log/LogMetadata"
import type { ILogbookModel, IModelCalculations } from "./Model"
import type { ILogCalculationsV2 } from "./Statistics/CalculationsV2"
import type { IStatus } from "./Status"
import type { ICalculationResult, IStoredCalculationSource } from "./StoredCalculation"
import type { ICalculated } from "./StoredCalculation/Calculated"
import type { ILogWeather } from "./Weather"

export interface ILog extends ICalculated<ILogCalculations>, ILogbookModel {
  id: number;
  cruiseId: number;
  tripId: number;
  dayId: number;
  accountId: number;
  shipId: number;
  userId?: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  discardedAt?: string;
  comment?: string;
  course?: number;
  depth?: number;
  distance?: number;
  engineRpms?: number[];
  heading?: number;
  labels?: string[];
  lat?: number;
  lng?: number;
  log?: number;
  sog?: number;
  stw?: number;
  time: number;
  timeUtc: number;
  timezone: number;
  data: string;
  currentDirection?: string;
  currentSpeed?: number;
  humidity?: number;
  pressure?: number;
  seaState?: string;
  temperature?: number;
  weather?: ILogWeather;
  windDirection?: number;
  windSpeed?: number;
  watch?: string;
  watchComment?: string;
  nmeaPending?: boolean;
}

export interface ILogCalculations extends IModelCalculations {
  distance?: number;
}

export interface IStoredLogCalculation {
  id: number;
  sourceId: number;
  sourceType: IStoredCalculationSource;
  version: number;
  calculated: ILogCalculations;
  calculatedV2?: ILogCalculationsV2;
}

export interface ILogResponse {
  log: ILog;
  logs: ILog[];
  calculation?: ICalculationResult<ILogCalculations>;
  calculationV2?: ICalculationResult<ILogCalculationsV2>;
  auditLogEdits: IAuditLogEdit[];
  statuses: IStatus[];
}

export interface ILogsResponse {
  logs: ILog[];
  statuses: IStatus[];
  calculations: ICalculationResult<ILogCalculations>[];
  calculationsV2: IStoredLogCalculation[];
  auditLogEdits: IAuditLogEdit[];
}

export type ILogParsed = Omit<ILog, "data"> & { dataParsed: ILogMetadata };

export const Log = {
  parse(r: ILog): ILogParsed {
    return { ...r, dataParsed: r.data != null ? JSON.parse(r.data) : {} } as ILogParsed;
  },
};
